import { Camera } from "../../../SharedGL/Camera";
import { FlightGL } from "./Flight/FlightGL";
import {
  IAircraftRowSetting,
  IFlight,
  IFlightFlag,
  IGroundEvent,
  isFlight,
  TimelineEvent,
  IHighlightFlightSettings,
  IFlightFlagSubDoc,
  IFlightError,
} from "@vmosolutions/oc-interfaces";
import { invertHexColor, getFlightAlphaValue } from "../TimelineUtils";
import { BaseTimelineLabelsGL } from "../../../SharedGL/TimelineLabels/BaseTimelineLabelsGL";
import { BaseTimelineGL } from "../../../SharedGL/BaseTimelineGL";
import { ScrollBarWrapper } from "../../../SharedGL/ScrollBar/ScrollBarWrapper";
import { defaultAircraftRowSetting } from "./TimelineGL";

interface IEventFlagIcons {
  [eventFlag: string]: HTMLImageElement;
}

interface IFlightLabelInfo {
  minFlightPixels: number;
  startX: number;
  endX: number;
  totalWidth: number;
  prevEndX: number;
  nextStartX: number;
  midX: number;
  flightNumberTextWidth: number;
}

// const FONT_SIZE_DELAYED_FLIGHT = Math.max(FlightGL.scheduledHeight * 0.8, 7); //scheduled flight times
// const FONT_SIZED_BASE = Math.max(FlightGL.actualDepartureHeight * 0.5, 8); // this is for the location labels
// const FONT_SIZE_FLIGHT_TIME = Math.max(FlightGL.aircraftRowHeight * 0.214, 8); //actual flight times
// const FONT_SIZE_FLIGHT_LABELS = Math.max(FlightGL.actualDepartureHeight * 0.55, 9); //flight number & release icon size
// console.log(FONT_SIZE_DELAYED_FLIGHT, FONT_SIZED_BASE, FONT_SIZE_FLIGHT_TIME, FONT_SIZE_FLIGHT_LABELS);
// const FONT_SIZE_DELAYED_FLIGHT = 8; //scheduled flight times
// const FONT_SIZED_BASE = 10; // not sure what this one is for
// const FONT_SIZE_FLIGHT_TIME = 9; //actual flight times
// const FONT_SIZE_FLIGHT_LABELS = 11; //flight number & release icon size
//TODO: This should probably be a customer setting.
const UNRELEASED_SHOW_FORWARD = 24 * 60 * 60 * 1000;
const UNRELEASED_SHOW_BACKWARD = 12 * 60 * 60 * 1000;

// const textOffset = FlightGL.actualDepartureStart + FlightGL.actualDepartureHeight / 2.0; //16
// const airportTextOffset = (FlightGL.actualDepartureStart + FlightGL.actualDepartureHeight) * 1.19; //32
// const timeTextOffset = (FlightGL.actualDepartureStart + FlightGL.actualDepartureHeight) * 0.875; //22
// const scheduledTimeTextOffset = FlightGL.scheduledStart * 4;
// console.log("SS", FlightGL.scheduledStart);
// const padding = FlightGL.actualDepartureStart / 3; //4
const assetPath = "assets/timeline-icons/";
const departureMovementMessage = "depMovementMessage";
const arrivalMovementMessage = "arrMovementMessage";
const oneMinute = 1000 * 60;
const oneHour = oneMinute * 60;
const oneDay = oneHour * 24;
// const movementMessageWindow = 30 * oneMinute;

// const movementMessageIconSize = Math.max(12 * FlightGL.rowHeightPercentage, 10);
// const iconWidth = 16 * FlightGL.rowHeightPercentage;

const showMovementMessageDaysThreshold = 7;

const checkDayDiff = (localDay: number, UTCDay: number, origin = true): string => {
  if (localDay === UTCDay) {
    return "";
  } else {
    return `${localDay?.toString()}/`;
  }
};
export class TimelineLabelsGL extends BaseTimelineLabelsGL {
  private FONT_SIZE_DELAYED_FLIGHT = 8; //scheduled flight times
  private FONT_SIZED_BASE = 10; // this is for the location labels
  private FONT_SIZE_FLIGHT_TIME = 9; //actual flight times
  private FONT_SIZE_FLIGHT_LABELS = 11;

  private textOffset = 16;
  private airportLocationTextOffset = 32;
  private timeTextOffset = 22;
  private scheduledTimeTextOffset = 8;
  private xPadding = 4;
  private yPadding = 4;

  private movementMessageIconSize = 12;
  private iconWidth = 16;
  private iconWidthHalf = 8;
  private scheduledTextWidth = 0;
  private totalScheduledTextWidth = 0;
  private flightNumberTextWidth = 0;

  private yPos = 0;
  private airportYPos = 0;
  private timeYPos = 0;
  private flagsYPos = 0;
  private movementMessageYPos = 0;
  private midYPos = 0;
  private scheduledTimeYPos = 0;
  private airportWidth = 0;
  private eventFlagIcons: IEventFlagIcons = {};

  private devicePixelRatio = 1;

  private currentTimeX = 0;

  private isUTC = true;

  private flightFlags: IFlightFlag[] = [];

  private departureMovementMessageWindow = 30 * oneMinute;
  private arrivalMovementMessageWindow = 30 * oneMinute;

  private aircraftRowHeightSettings: IAircraftRowSetting = defaultAircraftRowSetting;
  //default settings
  constructor(
    mount: HTMLElement,
    width: number,
    height: number,
    font = "Arial",
    baseFontSize = 10,
    flightFlags: IFlightFlag[] = [],
    aircraftRowHeightSettings: IAircraftRowSetting = defaultAircraftRowSetting,
    customerSettings: {
      overdueDepartureMovementMsgMinutes: number | null;
      overdueArrivalMovementMsgMinutes: number | null;
    }
  ) {
    super(mount, width, height, font, baseFontSize);
    this.aircraftRowHeightSettings = aircraftRowHeightSettings;

    this.scheduledTextWidth = this.textWidth * 4;
    this.totalScheduledTextWidth = this.scheduledTextWidth * 2;

    this.FONT_SIZE_DELAYED_FLIGHT = Math.max(FlightGL.scheduledHeight * 0.8, 7); //scheduled flight times
    this.FONT_SIZED_BASE = Math.max(FlightGL.actualDepartureHeight * 0.5, 8); // this is for the location labels
    this.FONT_SIZE_FLIGHT_TIME = Math.max(FlightGL.aircraftRowHeight * 0.214, 8); //actual flight times
    this.FONT_SIZE_FLIGHT_LABELS = Math.max(FlightGL.actualDepartureHeight * 0.55, 9); //flight number & release icon size

    this.textOffset = FlightGL.actualDepartureStart + FlightGL.actualDepartureHeight / 2.0; //16
    this.airportLocationTextOffset = (FlightGL.actualDepartureStart + FlightGL.actualDepartureHeight) * 1.19; //32
    this.timeTextOffset = (FlightGL.actualDepartureStart + FlightGL.actualDepartureHeight) * 0.875; //22
    this.scheduledTimeTextOffset = FlightGL.scheduledStart * 4;
    this.yPadding = FlightGL.actualDepartureStart / 3; //4

    this.movementMessageIconSize = Math.max(12 * FlightGL.rowHeightPercentage, 10);
    this.iconWidth = 16 * FlightGL.rowHeightPercentage;
    this.iconWidthHalf = 8 * FlightGL.rowHeightPercentage;

    this.flightFlags = flightFlags;
    {
      const image = new Image();
      image.onload = () => {
        this.eventFlagIcons[departureMovementMessage] = image;
      };
      image.src = `${assetPath}${departureMovementMessage}.svg`;
    }
    {
      const image = new Image();
      image.onload = () => {
        this.eventFlagIcons[arrivalMovementMessage] = image;
      };
      image.src = `${assetPath}${arrivalMovementMessage}.svg`;
    }

    this.departureMovementMessageWindow = (customerSettings.overdueDepartureMovementMsgMinutes ?? 30) * oneMinute;
    this.arrivalMovementMessageWindow = (customerSettings.overdueArrivalMovementMsgMinutes ?? 30) * oneMinute;
  }

  public setAircraftRowHeightSettings = (aircraftRowHeightSettings: IAircraftRowSetting): void => {
    this.aircraftRowHeightSettings = aircraftRowHeightSettings;
  };
  private getStartMidMaxFlight = (flight: IFlight, camera: Camera): [number, number, number] => {
    const actualOut = new Date(flight.actualOut); //Block Time switch to Out/In
    const actualIn = new Date(flight.actualIn); //Block Time switch to Out/In

    const start = actualOut, //Block Time switch to Out/In
      end = actualIn; //Block Time switch to Out/In
    const minFlightPixels = camera.timeAxisToPixelCoords(start.getTime(), this.textCanvas.width);
    const startX = minFlightPixels >= 0 ? minFlightPixels : 0;
    const endX = camera.timeAxisToPixelCoords(end.getTime(), this.textCanvas.width);
    const totalWidth = endX - startX;
    const midX = minFlightPixels + totalWidth / 2.0;
    return [startX, midX, endX];
  };

  /**
   * This function loads the saved flight flags and applies them to the associated flag title.
   * @param flightFlags - FlightFlags are loaded from structures
   */
  public updateFlightFlags = (flightFlags: IFlightFlag[]): void => {
    flightFlags.forEach((flightFlag: IFlightFlag) => {
      if (!this.eventFlagIcons[flightFlag.title]) {
        const image = new Image();
        const flag = this.flightFlags?.find((flag) => flag.title === flightFlag.title);
        if (flag?.icon?.includes("<svg")) {
          image.onload = () => {
            this.eventFlagIcons[flightFlag.title] = image;
          };
          const svgBlob = new Blob([flag.icon], { type: "image/svg+xml" });
          const svgURL = URL.createObjectURL(svgBlob);
          image.src = svgURL;
          // Clean up the URL once the image has ben loaded (see..https://dev.to/benjaminblack/using-a-string-of-svg-as-an-image-source-8mo)
          image.addEventListener("load", () => URL.revokeObjectURL(svgURL), { once: true });
          // Deprecated method using static flags stored in assets.
          // image.src = `${assetPath}${flightFlag.title}.svg`;
        }
      }
    });
  };

  public setIsUTC = (value: boolean): void => {
    this.isUTC = value;
  };

  public setIsICAO = (value: boolean): void => {
    this.isICAO = value;
  };

  // public drawFlightLabels = (
  //   camera: Camera,
  //   rowFlights: IFlight[],
  //   row: number,
  //   flightIndexes: number[],
  //   hoveredEvent: TimelineEvent
  // ): void => {
  //   const [yMin] = camera.getYRange();

  //   const fontSize = Math.round(this.FONT_SIZED_BASE * window.devicePixelRatio);
  //   this.SetFont(fontSize);
  //   this.flightNumberTextWidth = this.textCanvasCtx.measureText("M").width;
  //   // const [minX, maxX] = camera.getXRange();
  //   this.devicePixelRatio = window.devicePixelRatio || 1;
  //   const timelineStart = BaseTimelineGL.timelineStart; // * window.devicePixelRatio;
  //   const y0 = FlightGL.aircraftRowTotalHeight * row + timelineStart;
  //   const delta = y0 - yMin;
  //   this.yPos = delta + this.textOffset;
  //   this.airportYPos = delta + this.airportLocationTextOffset;
  //   this.timeYPos = delta + this.timeTextOffset;
  //   this.scheduledTimeYPos = delta + this.scheduledTimeTextOffset;

  //   // I kinda give up as to why it's not aligning vertically as expected, so that's the +2
  //   this.midYPos = delta + 2 + FlightGL.actualDepartureStart + FlightGL.actualDepartureHeight / 2.0; // + (this.devicePixelRatio * FlightGL.aircraftRowHeight) / 2.0;
  //   //debugger;
  //   this.airportWidth = this.textWidth * 4;
  //   this.movementMessageYPos = (delta + FlightGL.actualDepartureStart * 0.5) * this.devicePixelRatio;
  //   this.flagsYPos =
  //     (delta + FlightGL.actualDepartureStart + FlightGL.actualDepartureHeight / 2) * this.devicePixelRatio;
  //   // this.minPixel = camera.timeAxisToPixelCoords(minX, this.textCanvas.width);
  //   // this.maxPixel =
  //   if (this.yPos - FlightGL.actualDepartureHeight / 2.0 - BaseTimelineGL.timelineStart < 0) {
  //     return;
  //   }
  //   // }
  //   this.currentTimeX = 0;

  //   const [minIndex, maxIndex] = flightIndexes;
  //   for (let i = minIndex; i <= maxIndex; i++) {
  //     const flight = rowFlights[i];
  //     if (!flight) {
  //       continue;
  //     }

  //     let start = flight.actualOut, //Block Time switch to Out/In
  //       end = flight.actualIn; //Block Time switch to Out/In
  //     if (start > end) {
  //       const temp = start;
  //       start = end;
  //       end = temp;
  //     }
  //     const minFlightPixels = camera.timeAxisToPixelCoords(start, this.textCanvas.width);
  //     const startX = minFlightPixels >= 0 ? minFlightPixels : 0;
  //     const endX = camera.timeAxisToPixelCoords(end, this.textCanvas.width);
  //     const totalWidth = endX - startX;

  //     const now = Date.now();
  //     const flightDeparture = flight.actualOut || flight.scheduledOut;
  //     const unreleasedShow =
  //       !flight.isReleased &&
  //       flightDeparture > now - UNRELEASED_SHOW_BACKWARD &&
  //       flightDeparture < now + UNRELEASED_SHOW_FORWARD;
  //     const flightNumberTextWidth =
  //       this.flightNumberTextWidth * (flight.flightNumber.toString().length + (unreleasedShow ? 2 : 0));

  //     const prevFlight = i > 0 ? rowFlights[i - 1] : null;
  //     const nextFlight = i + 1 < rowFlights.length ? rowFlights[i + 1] : null;

  //     const prevEndX = prevFlight?.actualIn
  //       ? camera.timeAxisToPixelCoords(prevFlight.actualIn, this.textCanvas.width)
  //       : 0;
  //     const nextStartX = nextFlight?.actualOut
  //       ? camera.timeAxisToPixelCoords(nextFlight.actualOut, this.textCanvas.width)
  //       : this.textCanvas.width;
  //     const midX = minFlightPixels + totalWidth / 2.0;
  //     const flightLabelInfo: IFlightLabelInfo = {
  //       minFlightPixels,
  //       startX,
  //       endX,
  //       totalWidth,
  //       prevEndX,
  //       nextStartX,
  //       midX,
  //       flightNumberTextWidth,
  //     };

  //     // this.textCanvasCtx.font = "normal 8px '${FONT_DEFAULT}'";
  //     this.SetFont();
  //     this.drawFlightOrigDest(camera, flight, prevFlight, nextFlight);

  //     const isFlightHovered = hoveredEvent?._id === flight._id; // >= flight.actualOut && hoveredTime <= flight.actualIn;

  //     if (totalWidth >= flightNumberTextWidth) {
  //       let fontSize = Math.round(this.FONT_SIZE_FLIGHT_TIME * window.devicePixelRatio);
  //       this.SetFont(fontSize); //Block Time switch to Out/In
  //       this.drawFlightTime(camera, flight, flightLabelInfo, prevFlight, nextFlight, isFlightHovered);
  //       fontSize = Math.round(this.FONT_SIZE_FLIGHT_LABELS * window.devicePixelRatio);
  //       this.SetFont(fontSize); //Block Time switch to Out/In
  //       this.drawActualFlightLabels(flight, camera, flightLabelInfo, unreleasedShow, prevFlight, nextFlight);
  //     }
  //   }
  // };

  public drawEventLabels = (
    camera: Camera,
    rowEvents: (IFlight | IGroundEvent)[], //events should be sorted by actualOff/actualStart
    row: number,
    hoveredEvent: TimelineEvent,
    highlightFlightSettings: IHighlightFlightSettings,
    flightErrors: IFlightError[]
  ): void => {
    const [yMin] = camera.getYRange();

    const fontSize = Math.round(this.FONT_SIZED_BASE * window.devicePixelRatio);
    this.SetFont(fontSize);
    this.flightNumberTextWidth = this.textCanvasCtx.measureText("M").width;
    // const [minX, maxX] = camera.getXRange();
    this.devicePixelRatio = window.devicePixelRatio || 1;
    const timelineStart = BaseTimelineGL.timelineStart; // * window.devicePixelRatio;
    const y0 = FlightGL.aircraftRowTotalHeight * row + timelineStart;
    const delta = y0 - yMin;
    this.yPos = delta + this.textOffset;
    this.airportYPos = delta + this.airportLocationTextOffset;
    this.timeYPos = delta + this.timeTextOffset;
    this.scheduledTimeYPos = delta + this.scheduledTimeTextOffset;

    // I kinda give up as to why it's not aligning vertically as expected, so that's the +2
    this.midYPos = delta + 2 + FlightGL.actualDepartureStart + FlightGL.actualDepartureHeight / 2.0; // + (this.devicePixelRatio * FlightGL.aircraftRowHeight) / 2.0;
    //debugger;
    this.airportWidth = this.textWidth * 4;
    this.movementMessageYPos = (delta + FlightGL.actualDepartureStart * 0.5) * this.devicePixelRatio;
    this.flagsYPos =
      (delta + FlightGL.actualDepartureStart + FlightGL.actualDepartureHeight / 2) * this.devicePixelRatio;
    if (this.yPos - FlightGL.actualDepartureHeight / 2.0 - BaseTimelineGL.timelineStart < 0) {
      return;
    }
    // }
    this.currentTimeX = 0;

    for (let i = 0; i <= rowEvents.length; i++) {
      const event = rowEvents[i];
      if (!event) {
        continue;
      }
      let start = isFlight(event) ? event.actualOut : event.actualStart, //Block Time switch to Out/In
        end = isFlight(event) ? event.actualIn : event.actualEnd; //Block Time switch to Out/In
      if (start > end) {
        const temp = start;
        start = end;
        end = temp;
      }
      const minFlightPixels = camera.timeAxisToPixelCoords(start?.valueOf(), this.textCanvas.width);
      const startX = minFlightPixels >= 0 ? minFlightPixels : 0;
      const endX = camera.timeAxisToPixelCoords(end?.valueOf(), this.textCanvas.width);
      const totalWidth = endX - startX;

      const now = Date.now();
      const flightDeparture = isFlight(event) ? event.actualOut || event.scheduledOut : null;
      const unreleasedShow =
        isFlight(event) &&
        !event.isReleased &&
        flightDeparture?.valueOf() > now - UNRELEASED_SHOW_BACKWARD &&
        flightDeparture?.valueOf() < now + UNRELEASED_SHOW_FORWARD;
      const suffixLength = isFlight(event) && event.flightNumberSuffix ? event.flightNumberSuffix.toString().length : 0;
      const flightNumberTextWidth = isFlight(event)
        ? this.flightNumberTextWidth * (event.flightNumber.toString().length + suffixLength + (unreleasedShow ? 2 : 0))
        : null;

      const prevEvent = i > 0 ? rowEvents[i - 1] : null;
      const nextEvent = i + 1 < rowEvents.length ? rowEvents[i + 1] : null;

      const prevEndX =
        isFlight(prevEvent) && prevEvent?.actualIn
          ? camera.timeAxisToPixelCoords(prevEvent.actualIn?.valueOf(), this.textCanvas.width)
          : !isFlight(prevEvent) && prevEvent?.actualEnd
            ? camera.timeAxisToPixelCoords(prevEvent.actualEnd?.valueOf(), this.textCanvas.width)
            : 0;
      const nextStartX =
        isFlight(nextEvent) && nextEvent?.actualOut
          ? camera.timeAxisToPixelCoords(nextEvent.actualOut?.valueOf(), this.textCanvas.width)
          : !isFlight(nextEvent) && nextEvent?.actualStart
            ? camera.timeAxisToPixelCoords(nextEvent.actualStart?.valueOf(), this.textCanvas.width)
            : this.textCanvas.width;
      const prevLocation =
        isFlight(prevEvent) && prevEvent?.destination
          ? prevEvent?.destination
          : !isFlight(prevEvent) && prevEvent?.location
            ? prevEvent?.location
            : null;
      const nextLocation =
        isFlight(nextEvent) && nextEvent?.origin
          ? nextEvent?.origin
          : !isFlight(nextEvent) && nextEvent?.location
            ? nextEvent?.location
            : null;
      const midX = minFlightPixels + totalWidth / 2.0;

      // const isEventHovered = hoveredEvent?._id === event._id; // >= flight.actualOut && hoveredTime <= flight.actualIn;

      if (isFlight(event)) {
        const flightLabelInfo: IFlightLabelInfo = {
          minFlightPixels,
          startX,
          endX,
          totalWidth,
          prevEndX,
          nextStartX,
          midX,
          flightNumberTextWidth,
        };

        // If highlightFlights boolean is true and there are conditions passed in, set flight alpha based on those user supplied conditions;
        const labelAlpha =
          highlightFlightSettings?.active && !!highlightFlightSettings?.conditions
            ? getFlightAlphaValue(event, highlightFlightSettings)
            : 1.0;

        // this.textCanvasCtx.font = "normal 8px '${FONT_DEFAULT}'";
        this.SetFont();
        this.drawFlightOrigDest(camera, event, prevEndX, prevLocation, nextStartX, nextLocation, labelAlpha);

        if (totalWidth >= flightNumberTextWidth) {
          let fontSize = Math.round(this.FONT_SIZE_FLIGHT_TIME * window.devicePixelRatio);
          this.SetFont(fontSize); //Block Time switch to Out/In

          // If flight has a warning error, render it's label in dark grey for visibility on both black and yellow - CC
          //The flight could have multiple errors - so just want to know if the the only flight errors are of type warning
          // and timeline visiable
          const timelineFlightErrors = flightErrors?.filter(
            (error) => error.flightId === event._id && !error.hideFromTimeline
          );
          const labelColor =
            timelineFlightErrors.some((err) => err.priority === "WARNING") &&
            !timelineFlightErrors.some((err) => err.priority === "CRITICAL")
              ? "#444444"
              : "#FFFFFF";
          this.drawFlightTime(camera, event, flightLabelInfo, labelAlpha, labelColor);

          fontSize = Math.round(this.FONT_SIZE_FLIGHT_LABELS * window.devicePixelRatio);
          this.SetFont(fontSize); //Block Time switch to Out/In
          this.drawActualFlightLabels(event, camera, flightLabelInfo, unreleasedShow, null, null, labelAlpha);
        }
      } else {
        const labelAlpha =
          highlightFlightSettings?.active &&
          !!highlightFlightSettings?.conditions &&
          (highlightFlightSettings.conditions?.flightNumber?.length > 0 ||
            highlightFlightSettings.conditions?.flightType?.length > 0 ||
            highlightFlightSettings.conditions?.origin?.length > 0 ||
            highlightFlightSettings.conditions?.destination?.length > 0 ||
            highlightFlightSettings.conditions?.dispatchDesk?.length > 0 ||
            highlightFlightSettings.conditions?.highlightUnassigned)
            ? highlightFlightSettings.dimmSetting
            : 1.0;
        this.drawGroundEventLabels(event, camera, labelAlpha, prevLocation, nextLocation);
      }
    }
  };

  private calculateDrawTime = (
    depText: string,
    arrText: string,
    startX: number,
    endX: number,
    totalWidth: number
  ): [[number, number], [number, number]] | null => {
    const buffer = 10;
    const depTextWidth = this.textCanvasCtx.measureText(depText).width;
    const arrTextWidth = this.textCanvasCtx.measureText(arrText).width;

    if (arrTextWidth + buffer + depTextWidth > totalWidth) {
      return null;
    }

    const arrX = endX - arrTextWidth;
    return [
      [startX, depTextWidth],
      [arrX, arrTextWidth],
    ];
  };

  /**
   * DRAW BLOCK TIMES
   * @param camera -
   * @param flight -
   * @param flightLabelInfo -
   * @param prevFlight -
   * @param nextFlight -
   * @param isFlightHovered -
   * @param labelAlpha -
   */
  private drawFlightTime = (
    camera: Camera,
    flight: IFlight,
    flightLabelInfo: IFlightLabelInfo,
    labelAlpha: number,
    labelColor?: string
  ): void => {
    const actualOut = new Date(flight.actualOut); //Block Time switch to Out/In
    const actualIn = new Date(flight.actualIn); //Block Time switch to Out/In
    const { actualInLocal, actualOutLocal } = flight;

    // Shift all flight times to the right by 7 pixels (this helps center them under the flight block)
    const { startX, endX, totalWidth } = flightLabelInfo;
    this.textCanvasCtx.save();

    // Apply default label color plus supplied alpha setting.
    const defaultFillColor = labelColor ?? "#FFFFFF";
    this.textCanvasCtx.globalAlpha = labelAlpha;
    this.textCanvasCtx.fillStyle = defaultFillColor; //hexToCSSRGBA(defaultFillColor, labelAlpha);

    /* Origin Text */
    const depHoursStr = this.isUTC
      ? actualOut.getUTCHours() < 10
        ? `0${actualOut.getUTCHours()}`
        : `${actualOut.getUTCHours()}`
      : actualOutLocal?.hour < 10
        ? `${checkDayDiff(actualOutLocal?.day, actualOut.getUTCDate())}0${actualOutLocal.hour}`
        : `${checkDayDiff(actualOutLocal?.day, actualOut.getUTCDate())}${actualOutLocal?.hour}`; //Block Time switch to Out/In
    const depMinsStr = this.isUTC
      ? actualOut.getUTCMinutes() < 10
        ? `0${actualOut.getUTCMinutes()}`
        : `${actualOut.getUTCMinutes()}` //Block Time switch to Out/In
      : actualOutLocal?.minute < 10
        ? `0${actualOutLocal.minute}`
        : `${actualOutLocal?.minute}`;

    /* Destination text */
    const arrivalHoursStr = this.isUTC
      ? actualIn.getUTCHours() < 10
        ? `0${actualIn.getUTCHours()}`
        : `${actualIn.getUTCHours()}`
      : actualInLocal?.hour < 10
        ? `${checkDayDiff(actualInLocal?.day, actualIn.getUTCDate(), false)}0${actualInLocal.hour}`
        : `${checkDayDiff(actualInLocal?.day, actualIn.getUTCDate(), false)}${actualInLocal?.hour}`;
    //Block Time switch to Out/In
    const arrivalMinsStr = this.isUTC
      ? actualIn.getUTCMinutes() < 10
        ? `0${actualIn.getUTCMinutes()}`
        : `${actualIn.getUTCMinutes()}`
      : actualInLocal?.minute < 10
        ? `0${actualInLocal.minute}`
        : `${actualInLocal?.minute}`;

    const drawCalcs = this.calculateDrawTime(
      depHoursStr + depMinsStr,
      arrivalHoursStr + arrivalMinsStr,
      startX,
      endX,
      totalWidth
    );

    if (drawCalcs) {
      const y = this.airportYPos * this.devicePixelRatio;
      this.textCanvasCtx.fillText(
        !this.isUTC && !actualOutLocal ? "Missing tz info" : depHoursStr + depMinsStr,
        drawCalcs[0][0],
        y,
        drawCalcs[0][1]
      );
      this.textCanvasCtx.fillText(
        !this.isUTC && !actualInLocal ? "Missing tz info" : arrivalHoursStr + arrivalMinsStr,
        drawCalcs[1][0],
        y,
        drawCalcs[1][1]
      );
    }

    // Restore the text canvas controls back to their saved values;
    this.textCanvasCtx.restore();
  };

  /**
   * DRAW ORIGIN / DESTINATION LABELS
   * @param camera -
   * @param flight -
   * @param prevFlight -
   * @param nextFlight -
   * @param labelAlpha -
   * @returns -
   */
  private drawFlightOrigDest = (
    camera: Camera,
    flight: IFlight,
    prevEventEndX: number | null,
    prevEventLocation: string | null,
    nextEventStartX: number | null,
    nextEventLocation: string | null,
    labelAlpha: number
  ): void => {
    const [startX, , endX] = this.getStartMidMaxFlight(flight, camera);

    if (startX > this.textCanvas.width || endX < 0) {
      return;
    }

    this.textCanvasCtx.save();

    // Apply default label color plus supplied alpha setting.
    const defaultFillColor = "#FFFFFF";
    this.textCanvasCtx.globalAlpha = labelAlpha;
    this.textCanvasCtx.fillStyle = defaultFillColor; //hexToCSSRGBA(defaultFillColor, labelAlpha);

    const width = this.airportWidth; //this.textWidth * flight.origin.length;
    const paddedWidth = 2 * (width + this.xPadding * 2);
    // const originalTextAlign = this.textCanvasCtx.textAlign;
    this.textCanvasCtx.textAlign = "end";
    this.SetFont(this.FONT_SIZED_BASE * window.devicePixelRatio);
    const originText = this.isICAO ? flight.origin : (flight.originAirport?.IATACode ?? "Missing apt info");
    const destinationText = this.isICAO ? flight.destination : (flight.destAirport?.IATACode ?? "Missing apt info");

    if (prevEventEndX && prevEventLocation) {
      //this.drawTestBox(startX - width - padding * 2, this.midYPos * this.devicePixelRatio - 6, paddedWidth, 12);
      // const prevEndX = camera.timeAxisToPixelCoords(prevFlight.actualIn, this.textCanvas.width); //Block Time switch to Out/In
      const origWidth = startX - prevEventEndX - this.xPadding;
      if (origWidth > paddedWidth) {
        if (flight.origin !== prevEventLocation) {
          this.drawWarnBoxAroundText(
            startX - (2 + this.xPadding / 2 + paddedWidth / 2) / this.devicePixelRatio,
            (this.midYPos + this.yPadding - 1) * this.devicePixelRatio - this.BASE_FONT_SIZE,
            (2 + this.xPadding / 2 + paddedWidth / 2) / this.devicePixelRatio,
            this.BASE_FONT_SIZE + this.yPadding
          );
        }
        this.textCanvasCtx.fillText(originText, startX - this.xPadding, this.midYPos * this.devicePixelRatio);
      }
    } else {
      this.textCanvasCtx.fillText(originText, startX - this.xPadding, this.midYPos * this.devicePixelRatio);
    }

    const curEndX = camera.timeAxisToPixelCoords(flight.actualIn?.valueOf(), this.textCanvas.width);
    if (nextEventStartX && nextEventLocation) {
      // const nextStartX = camera.timeAxisToPixelCoords(nextFlight.actualOut, this.textCanvas.width); //Block Time switch to Out/In
      const destWidth = nextEventStartX - endX - this.xPadding;
      if (destWidth > paddedWidth && curEndX + width < this.textCanvas.width - ScrollBarWrapper.scrollBarWidth) {
        if (nextEventLocation !== flight.destination) {
          this.drawWarnBoxAroundText(
            endX + this.xPadding / 2 / this.devicePixelRatio,
            (this.midYPos + this.yPadding - 1) * this.devicePixelRatio - this.BASE_FONT_SIZE,
            (2 + this.xPadding / 2 + paddedWidth / 2) / this.devicePixelRatio,
            this.BASE_FONT_SIZE + this.yPadding
          );
        }
        this.textCanvasCtx.textAlign = "start";
        this.textCanvasCtx.fillText(destinationText, endX + this.xPadding, this.midYPos * this.devicePixelRatio);
        //if the flight was diverted, show original destination
        if (flight.divertedFrom) {
          // this.textCanvasCtx.fillStyle = "yellow";
          this.textCanvasCtx.fillText(
            `[${flight.divertedFrom}]`,
            endX + this.xPadding,
            this.airportYPos * this.devicePixelRatio
          );
        }
      } else if (
        destWidth > paddedWidth / 2 &&
        curEndX + width / 2 < this.textCanvas.width - ScrollBarWrapper.scrollBarWidth
      ) {
        this.textCanvasCtx.textAlign = "center";
        this.textCanvasCtx.fillStyle = nextEventLocation === flight.destination ? defaultFillColor : "yellow";
        this.textCanvasCtx.fillText(
          nextEventLocation === flight.destination ? destinationText : "⚠⚠⚠⚠",
          endX + (nextEventStartX - endX) / 2,
          this.midYPos * this.devicePixelRatio
        );
      } else if (
        destWidth > paddedWidth / 6 &&
        curEndX + width / 2 < this.textCanvas.width - ScrollBarWrapper.scrollBarWidth
      ) {
        this.textCanvasCtx.textAlign = "center";
        this.textCanvasCtx.fillStyle = nextEventLocation === flight.destination ? defaultFillColor : "yellow";
        this.textCanvasCtx.fillText(
          nextEventLocation === flight.destination ? destinationText?.substr(-2) : "⚠⚠",
          endX + (nextEventStartX - endX) / 2,
          this.midYPos * this.devicePixelRatio
        );
      }
    } else {
      if (curEndX + width < this.textCanvas.width - ScrollBarWrapper.scrollBarWidth) {
        this.textCanvasCtx.textAlign = "start";
        this.textCanvasCtx.fillText(destinationText, endX + this.xPadding, this.midYPos * this.devicePixelRatio);
      }
    }

    // Restore the text canvas controls back to their saved values;
    this.textCanvasCtx.restore();
  };

  // public drawGroundEventsLabels = (
  //   camera: Camera,
  //   groundEvents: IGroundEvent[],
  //   row: number,
  //   groundEventIndexes: number[]
  // ): void => {
  //   const [minIndex, maxIndex] = groundEventIndexes;
  //   for (let i = minIndex; i <= maxIndex; i++) {
  //     const groundEvent = groundEvents[i];
  //     if (!groundEvent) {
  //       continue;
  //     }

  //     this.drawGroundEventLabels(groundEvent, camera);
  //   }
  // };

  private drawGroundEventLabels = (
    groundEvent: IGroundEvent,
    camera: Camera,
    labelAlpha = 1,
    prevEventLocation: string | null,
    nextEventLocation: string | null
  ): void => {
    const actualOut = new Date(groundEvent.actualStart); //Block Time switch to Out/In
    const actualIn = new Date(groundEvent.actualEnd); //Block Time switch to Out/In
    this.textCanvasCtx.globalAlpha = labelAlpha;
    let locationText = this.isICAO
      ? groundEvent.location
      : (groundEvent.locationAirport?.IATACode ?? "Missing apt info");
    const showLocationWarning =
      (prevEventLocation && groundEvent?.location !== prevEventLocation) ||
      (nextEventLocation && groundEvent?.location !== nextEventLocation);

    const { actualStartLocal, actualEndLocal } = groundEvent;
    let start = actualOut, //Block Time switch to Out/In
      end = actualIn; //Block Time switch to Out/In
    if (start > end) {
      const temp = start;
      start = end;
      end = temp;
    }
    const minFlightPixels = camera.timeAxisToPixelCoords(start.getTime(), this.textCanvas.width);
    const startX = minFlightPixels >= 0 ? minFlightPixels : 0;
    const endX = camera.timeAxisToPixelCoords(end.getTime(), this.textCanvas.width);
    const totalWidth = endX - startX;
    const midX = startX + totalWidth / 2.0;

    if (
      groundEvent.title &&
      this.flightNumberTextWidth * (locationText.length + groundEvent.title.length + 1) < totalWidth
    ) {
      locationText = locationText.concat("-", groundEvent.title);
    }

    const groundEventTextWidth = this.flightNumberTextWidth * locationText.length;
    const halfGroundEventTextWidth = groundEventTextWidth / 2.0;
    this.textCanvasCtx.fillStyle = invertHexColor(groundEvent.eventType?.color ?? "#FFFFFF");
    const endOfText: number = midX + halfGroundEventTextWidth;
    const startOfScroll = this.textCanvas.width - ScrollBarWrapper.scrollBarWidth;
    //is there space to draw this? dont draw on the scroll bar or off the event
    if (endOfText < startOfScroll && endOfText < endX) {
      this.textCanvasCtx.fillText(locationText, midX - halfGroundEventTextWidth, this.yPos * this.devicePixelRatio);
      if (showLocationWarning) {
        this.drawWarnBoxAroundText(
          midX - halfGroundEventTextWidth - this.xPadding / 2 / this.devicePixelRatio,
          (this.yPos + this.yPadding - 1) * this.devicePixelRatio - this.BASE_FONT_SIZE,
          this.textCanvasCtx.measureText(locationText).width + this.xPadding / this.devicePixelRatio,
          this.BASE_FONT_SIZE + this.yPadding
        );
      }
    }
    this.textCanvasCtx.fillStyle = "#FFFFFF";

    if (totalWidth > groundEventTextWidth) {
      /* Origin Text */
      const depHoursStr = this.isUTC
        ? actualOut.getUTCHours() < 10
          ? `0${actualOut.getUTCHours()}`
          : `${actualOut.getUTCHours()}`
        : actualStartLocal?.hour < 10
          ? `0${actualStartLocal.hour}`
          : `${actualStartLocal?.hour}`; //Block Time switch to Out/In
      const depMinsStr = this.isUTC
        ? actualOut.getUTCMinutes() < 10
          ? `0${actualOut.getUTCMinutes()}`
          : `${actualOut.getUTCMinutes()}`
        : actualStartLocal?.minute < 10
          ? `0${actualStartLocal.minute}`
          : `${actualStartLocal?.minute}`; //Block Time switch to Out/In
      this.drawAirportTime(
        !this.isUTC && !actualStartLocal ? "Missing tz info" : depHoursStr + depMinsStr,
        startX + this.xPadding,
        endX - groundEventTextWidth - this.xPadding,
        0,
        this.textCanvas.width
      );

      /* Destination text */
      const arrivalHoursStr = this.isUTC
        ? actualIn.getUTCHours() < 10
          ? `0${actualIn.getUTCHours()}`
          : `${actualIn.getUTCHours()}`
        : actualEndLocal?.hour < 10
          ? `0${actualEndLocal.hour}`
          : `${actualEndLocal?.hour}`;
      //Block Time switch to Out/In
      const arrivalMinsStr = this.isUTC
        ? actualIn.getUTCMinutes() < 10
          ? `0${actualIn.getUTCMinutes()}`
          : `${actualIn.getUTCMinutes()}`
        : actualEndLocal?.minute < 10
          ? `0${actualEndLocal.minute}`
          : `${actualEndLocal?.minute}`;
      //Block Time switch to Out/In
      this.drawAirportTime(
        !this.isUTC && !actualEndLocal ? "Missing tz info" : arrivalHoursStr + arrivalMinsStr,
        midX + this.xPadding,
        endX - this.xPadding,
        0,
        this.textCanvas.width,
        true
      );
    }
    this.textCanvasCtx.globalAlpha = 1.0; //set it back for drawing the time axis etc
  };

  public drawDelayedFlightLabels = (
    camera: Camera,
    delayedFlights: IFlight[],
    flightsInRange: number[],
    highlightFlightSettings: IHighlightFlightSettings
  ): void => {
    const [minIndex, maxIndex] = flightsInRange;
    if (minIndex < 0 || maxIndex >= delayedFlights.length) {
      return;
    }

    this.textCanvasCtx.save();
    const fontSize = Math.round(this.FONT_SIZE_DELAYED_FLIGHT * window.devicePixelRatio);
    this.SetFont(fontSize); //Block Time switch to Out/In
    for (let i = minIndex; i <= maxIndex; i++) {
      const delayedFlight: IFlight = delayedFlights[i];

      // If highlightFlights boolean is true and there are conditions passed in, set flight alpha based on those user supplied conditions;
      const labelAlpha = getFlightAlphaValue(delayedFlight, highlightFlightSettings);

      const color = delayedFlight && delayedFlight.flightType ? delayedFlight.flightType.color : "FFFFFF";
      this.textCanvasCtx.fillStyle = invertHexColor(color);
      this.textCanvasCtx.globalAlpha = labelAlpha;

      const { scheduledOut, scheduledIn, scheduledOutLocal, scheduledInLocal } = delayedFlight;
      const [departure, arrival] = [new Date(scheduledOut), new Date(scheduledIn)];
      const minFlightPixels = camera.timeAxisToPixelCoords(departure?.valueOf(), this.textCanvas.width);
      const startX = minFlightPixels >= 0 ? minFlightPixels : 0;
      const endX = camera.timeAxisToPixelCoords(arrival?.valueOf(), this.textCanvas.width);
      const totalWidth = endX - startX;

      const canvasWidth = this.textCanvas.width - ScrollBarWrapper.scrollBarWidth;

      if (this.totalScheduledTextWidth <= totalWidth) {
        //check if you should draw Origin Time text
        if (startX + this.scheduledTextWidth < canvasWidth) {
          /* Origin Time Text */

          const departureHourStr = this.isUTC
            ? departure.getUTCHours() < 10
              ? "0" + departure.getUTCHours()
              : departure.getUTCHours()
            : scheduledOutLocal?.hour < 10
              ? `${checkDayDiff(scheduledOutLocal?.day, departure.getUTCDate())}0${scheduledOutLocal.hour}`
              : `${checkDayDiff(scheduledOutLocal?.day, departure.getUTCDate())}${scheduledOutLocal?.hour}`;
          //Block Time switch to Out/In
          const departureMinStr = this.isUTC
            ? departure.getUTCMinutes() < 10
              ? `0${departure.getUTCMinutes()}`
              : `${departure.getUTCMinutes()}` //Block Time switch to Out/In
            : scheduledOutLocal?.minute < 10
              ? `0${scheduledOutLocal.minute}`
              : `${scheduledOutLocal?.minute}`;

          this.textCanvasCtx.fillText(
            !this.isUTC && !scheduledOutLocal ? "Missing tz info" : `${departureHourStr}${departureMinStr}`,
            startX,
            this.scheduledTimeYPos * this.devicePixelRatio
          );
        }
        //check if you should draw Destination Time text
        if (endX < canvasWidth) {
          /* Destination Time text */

          const arrivalHourStr = this.isUTC
            ? arrival.getUTCHours() < 10
              ? "0" + arrival.getUTCHours()
              : arrival.getUTCHours()
            : scheduledInLocal?.hour < 10
              ? `${checkDayDiff(scheduledInLocal?.day, arrival.getUTCDate(), false)}0${scheduledInLocal.hour}`
              : `${checkDayDiff(scheduledInLocal?.day, arrival.getUTCDate(), false)}${scheduledInLocal?.hour}`;
          //Block Time switch to Out/In
          const arrivalMinStr = this.isUTC
            ? arrival.getUTCMinutes() < 10
              ? "0" + arrival.getUTCMinutes()
              : arrival.getUTCMinutes() //Block Time switch to Out/In
            : scheduledInLocal?.minute < 10
              ? `0${scheduledInLocal.minute}`
              : `${scheduledInLocal?.minute}`;

          this.textCanvasCtx.fillText(
            !this.isUTC && !scheduledInLocal ? "Missing tz info" : `${arrivalHourStr}${arrivalMinStr}`,
            endX - fontSize * 2, //- this.scheduledTextWidth
            this.scheduledTimeYPos * this.devicePixelRatio
          );
        }
      }
    }

    // Restore the text canvas controls back to their saved values;
    this.textCanvasCtx.restore();
  };

  /**
   * DRAW FLIGHT NUMBER/FLAGS and other flight icons.
   * @param flight -
   * @param camera -
   * @param flightLabelInfo -
   * @param unreleasedShow -
   * @param prevFlight -
   * @param nextFlight -
   * @param labelAlpha -
   */
  private drawActualFlightLabels = (
    flight: IFlight,
    camera: Camera,
    flightLabelInfo: IFlightLabelInfo,
    unreleasedShow: boolean,
    prevFlight: IFlight | null,
    nextFlight: IFlight | null,
    labelAlpha: number
  ): void => {
    const actualOut = new Date(flight.actualOut); //Block Time switch to Out/In
    const actualIn = new Date(flight.actualIn); //Block Time switch to Out/In

    const actualOff = new Date(flight.actualOff);
    const actualOn = new Date(flight.actualOn);

    const { minFlightPixels, startX, totalWidth, flightNumberTextWidth } = flightLabelInfo;
    let endX = flightLabelInfo.endX;
    const now = Date.now();
    this.textCanvasCtx.save();

    // Apply default label color plus supplied alpha setting.
    const defaultFillColor = flight.flightType ? invertHexColor(flight.flightType.color) : "#FF0000";
    this.textCanvasCtx.globalAlpha = labelAlpha;
    this.textCanvasCtx.fillStyle = defaultFillColor; //hexToCSSRGBA(defaultFillColor, labelAlpha);

    const midX = minFlightPixels + totalWidth / 2.0;
    const adjustedFlightNumberTextWidth = unreleasedShow
      ? flightNumberTextWidth + this.textCanvasCtx.measureText(" 🟣").width
      : flightNumberTextWidth;
    if (flightNumberTextWidth + midX < this.textCanvas.width - ScrollBarWrapper.scrollBarWidth) {
      const origalign = this.textCanvasCtx.textAlign;
      this.textCanvasCtx.textAlign = "center";
      const flightNumberDisplay =
        flight.flightNumber.toString() +
        (flight.flightNumberSuffix ? flight.flightNumberSuffix : "") +
        (unreleasedShow ? " 🟣" : "");
      this.textCanvasCtx.fillText(flightNumberDisplay, midX, this.midYPos * window.devicePixelRatio);
      this.textCanvasCtx.textAlign = origalign;
    }
    //don't draw on the scroll bar
    if (flight.divertedFrom && endX < this.textCanvas.width - ScrollBarWrapper.scrollBarWidth) {
      this.SetFont(this.BASE_FONT_SIZE * 2.5, 300);
      //is there enough space to draw on the flight chip?
      if (adjustedFlightNumberTextWidth + this.iconWidth * window.devicePixelRatio < totalWidth) {
        this.textCanvasCtx.fillStyle = defaultFillColor;
        this.textCanvasCtx.fillText(
          "↪",
          endX - this.iconWidth * window.devicePixelRatio,
          this.midYPos * window.devicePixelRatio,
          this.iconWidth * window.devicePixelRatio
        );
        endX -= this.iconWidth * window.devicePixelRatio;
      }
    }
    const aircraftRequiresMessage = flight.aircraft.requireMessages;
    let showingMissingDepMessage = false;
    if (FlightGL.rowHeightPercentage >= 1) {
      let flagCount = 0;
      let currentX = startX + 2;
      flight.flags?.forEach((flag: IFlightFlagSubDoc) => {
        const image = this.eventFlagIcons[flag.title];
        if (!image) {
          return;
        }
        flagCount++;
        // This should ensure that flags don't occlude flight numbers.
        const minWidthToDisplayFlag = endX - flightNumberTextWidth - flagCount * this.iconWidth;
        const minWidthToDisplayTinyFlags = endX - flightNumberTextWidth - flagCount * this.iconWidthHalf;
        if (image && currentX + this.iconWidth <= minWidthToDisplayFlag) {
          this.textCanvasCtx.drawImage(
            image,
            currentX,
            this.flagsYPos - this.iconWidth / 2,
            this.iconWidth, // width
            this.iconWidth // height
          );
          currentX += this.iconWidth + 2;
          if (currentX + this.iconWidth >= midX && currentX + this.iconWidth <= midX + flightNumberTextWidth) {
            currentX = midX + flightNumberTextWidth + 8; // changed padding after flight number from 2 to 8
          }
        } else if (image && currentX + this.iconWidthHalf <= minWidthToDisplayTinyFlags) {
          this.textCanvasCtx.drawImage(
            image,
            currentX,
            this.flagsYPos - this.iconWidth / 2,
            this.iconWidthHalf, // width
            this.iconWidth // height
          );
          currentX += this.iconWidthHalf + 2;
          if (currentX + this.iconWidthHalf >= midX && currentX + this.iconWidthHalf <= midX + flightNumberTextWidth) {
            currentX = midX + flightNumberTextWidth + 8; // changed padding after flight number from 2 to 8
          }
        }
      });
      const [minX, maxX] = camera.getXRange();
      const numDays = Math.floor((maxX - minX) / oneDay);
      if (numDays <= showMovementMessageDaysThreshold && aircraftRequiresMessage) {
        //Block Time switch to Out/In
        const missingDepMovementMessage =
          now - actualOff.getTime() > this.departureMovementMessageWindow && !flight.receivedDepartureMessage
            ? departureMovementMessage
            : null;
        if (missingDepMovementMessage && minFlightPixels >= 0) {
          this.drawMovementMessages(startX + this.xPadding, endX, missingDepMovementMessage);
        }
        const missingArrMovementMessage =
          now - actualOn.getTime() > this.arrivalMovementMessageWindow && !flight.receivedArrivalMessage
            ? arrivalMovementMessage
            : null;

        if (missingArrMovementMessage && endX) {
          this.drawMovementMessages(startX, endX - this.xPadding, missingArrMovementMessage, true);
        }
      }
    } else {
      const [minX, maxX] = camera.getXRange();
      const numDays = Math.floor((maxX - minX) / oneDay);
      if (numDays <= showMovementMessageDaysThreshold && aircraftRequiresMessage) {
        //Block Time switch to Out/In
        const missingDepMovementMessage =
          now - actualOff.getTime() > this.departureMovementMessageWindow && !flight.receivedDepartureMessage
            ? departureMovementMessage
            : null;
        if (missingDepMovementMessage && minFlightPixels >= 0) {
          showingMissingDepMessage = true;
          this.drawMovementMessages(startX + this.xPadding, endX, missingDepMovementMessage);
        }
        const missingArrMovementMessage =
          now - actualOn.getTime() > this.arrivalMovementMessageWindow && !flight.receivedArrivalMessage
            ? arrivalMovementMessage
            : null;

        if (missingArrMovementMessage && endX) {
          this.drawMovementMessages(startX, endX - this.xPadding, missingArrMovementMessage, true);
        }
      }

      let currentX =
        showingMissingDepMessage && FlightGL.rowHeightPercentage < 1 ? startX + 4 + this.iconWidth : startX + 2;
      let flagCount = 0;
      flight.flags?.forEach((flag: IFlightFlagSubDoc) => {
        const image = this.eventFlagIcons[flag.title];
        if (!image) {
          return;
        }
        flagCount++;
        // This should ensure that flags don't occlude flight numbers.
        const minWidthToDisplayFlag = endX - flightNumberTextWidth - flagCount * this.iconWidth;

        if (image && currentX + this.iconWidth <= minWidthToDisplayFlag) {
          this.textCanvasCtx.drawImage(
            image,
            currentX,
            this.flagsYPos - this.iconWidth / 2,
            this.iconWidth,
            this.iconWidth
          );
          currentX += this.iconWidth + 2;
          if (currentX + this.iconWidth >= midX && currentX + this.iconWidth <= midX + flightNumberTextWidth) {
            currentX = midX + flightNumberTextWidth + 8; // changed padding after flight number from 2 to 8
          }
        }
      });
    }

    // Restore the text canvas controls back to their saved values;
    this.textCanvasCtx.restore();
  };

  private drawMovementMessages = (
    min: number,
    max: number,
    missingMovementMessage: string | null,
    isRightJustified = false
  ): void => {
    if (missingMovementMessage && this.eventFlagIcons[missingMovementMessage]) {
      this.textCanvasCtx.drawImage(
        this.eventFlagIcons[missingMovementMessage],
        isRightJustified ? max - this.movementMessageIconSize : min,
        FlightGL.rowHeightPercentage < 1 ? this.flagsYPos - this.movementMessageIconSize / 2 : this.movementMessageYPos,
        this.movementMessageIconSize,
        this.movementMessageIconSize
      );
    }
  };

  private drawAirportTime = (
    timeText: string,
    min: number,
    max: number,
    prevEndX: number,
    nextStartX: number,
    isRightJustified = false
  ): void => {
    const width = max - min;
    const textWidth = this.textWidth * timeText.length;

    const startX = isRightJustified ? max - textWidth : min;

    const endOfText: number = startX + textWidth;
    const startOfScroll = this.textCanvas.width - ScrollBarWrapper.scrollBarWidth;
    // this.textCanvasCtx.fillStyle = !this.isICAO ? "orange" : "#FFFFFF";
    if (endOfText >= startOfScroll) {
      return;
    }
    const halfWidth = textWidth / 2;
    if (width > textWidth) {
      this.textCanvasCtx.fillText(timeText, startX, this.airportYPos * this.devicePixelRatio, textWidth);
    } else {
      const delta = isRightJustified ? -(width - textWidth) : width - textWidth;
      const compare = isRightJustified ? nextStartX - halfWidth : prevEndX + halfWidth;
      const x = isRightJustified ? Math.min(startX + delta, compare) : Math.max(startX + delta, compare);
      this.textCanvasCtx.fillText(timeText, x, this.airportYPos * this.devicePixelRatio, textWidth);
    }
  };
}
